import apiClient from 'services/axios'
import ApiConfig from 'services/config'
// import errorHandler from 'components/error.handler'

function getCardDesign(businessCode) {
  return apiClient
    .get(`${ApiConfig.CardDesignConfig.CardDesign}${businessCode}`)
    .then(response => response?.data)
}

export default getCardDesign
